import React from 'react';
import PropTypes from 'prop-types';
import "./describe.scss";
import { LinkIconConfig } from '../../../config';
const Describe = props => {
    return (
        <div className='describe'>
            <div className='titleWrap'>
                <h1 className='title'>
                    Chính sách và điều khoản sử dụng dịch vụ
                </h1>
                <p className='text'>
                    Tìm hiểu thêm về cách Map4D thu thập và sử dụng dữ liệu cũng như các quyền của bạn với tư cách là người dùng Map4D.
                </p>
                <div className='horizontalLine' />
                <div className='dowloadPdf'>
                    <div className='situation'>
                        Cập nhật lần cuối vào Tháng 9, 2023
                    </div>
                    {/* <a className='link'>
                        Tải bản PDF xuống
                    </a> */}
                </div>
            </div>

            <div className='icon'>
                <div>
                    <img src={LinkIconConfig.policy} />
                </div>
            </div>
        </div>
    );
};

Describe.propTypes = {

};

export default Describe;